<template>
<b-modal id="modalRegistarCarCode" hide-footer hide-header no-close-on-backdrop no-close-on-esc @close="closeScan" size="lg">
	<div class="fullscreen" v-if="show">
		
		<!-- <Loader :show="loading"></Loader> -->
		<div class="code-reader transition" >
			<div class="btn " @click="closeScan()" ><i class="icon icon-close invert"></i></div>
			<StreamBarcodeReader @decode="onDecode" @init="onInit" ref="rootElement"></StreamBarcodeReader>
		</div>

	</div>
</b-modal>

</template>

<script>

import { StreamBarcodeReader } from "vue-barcode-reader"

export default {
	name: 'readCode',
	components:{
		StreamBarcodeReader,
	},
	props:['title'],
	data () {
		return {
			opened: false,
			show: false,
			beep: new Audio(require('@/assets/beep.mp3')),
			
		}
	},

	methods:{
		
		open() {
			this.show = true
			this.$bvModal.show('modalRegistarCarCode')
		},
		closeScan(){
			this.show = false
			this.$bvModal.hide('modalRegistarCarCode')
		},
		async onInit(promise){
			try{
				await promise
				this.opened = true
			} catch(error){
				console.log(error)
			}
		},
		onDecode(data){
			this.beep.play()
			if(data){
                this.$emit('readed', data)
				this.closeScan()
			}
			else{
				this.$toast.error('Error al leer el código')
				this.closeScan()
				return false 
			}
		},
		
	}
}


</script>

<style scoped>
.code-reader{
	width:100%;
	height:100%;
	z-index:2000;
	top:0px;
	position:fixed;
}

.btn{
	position: absolute;
	top: 22px;
	right: 10px;
	z-index: 11;
	font-size:18px;
	color:	#fff;
}

.layer{
	position:absolute;
	top:0;
	width:100%;
	height:100%;
	background:rgba(155,155,155,0.6) ;	
	z-index: 10;
	-webkit-clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
	clip-path: polygon(0% 0%, 0% 100%, 15% 100%, 15% 15%, 85% 15%, 85% 85%, 15% 85%, 15% 100%, 100% 100%, 100% 0%);
}

.scanner-container{
	width: 100%;
    height: 100%;
}
.code-reader /deep/ video{
	object-fit: cover;
    position:absolute;
    z-index:-1;
    top:0;
    left:0;
    width:100%; 
    height:100vh;
}
</style>
